import React from 'react'
import { PAYMENT_METHOD } from 'lib/core/resources/constants'
import { useCheckout } from 'lib/modules/checkout'
import { AffirmMain } from 'lib/modules/affirm'
import { AuthNet } from './components/AuthNet'
import { Braintree } from './components/Braintree'
import { BraintreePaypal } from './components/BraintreePaypal'
import { CheckMo } from './components/CheckMo'
import { Cybersource } from './components/Cybersource'
import { Klarna } from './components/Klarna'
import { MerchantE } from './components/MerchantE'
import { PayflowPro } from './components/PayflowPro'
import { PaypalExpress } from './components/PaypalExpress'
import { Free } from './components/Free'

export const PaymentMethods = () => {
  const { paymentMethod } = useCheckout()
  const { code } = paymentMethod

  let PaymentMethodComponent

  switch (code) {
    case PAYMENT_METHOD.AFFIRM: {
      PaymentMethodComponent = AffirmMain
      break
    }
    case PAYMENT_METHOD.AUTHNETCC: {
      PaymentMethodComponent = AuthNet
      break
    }
    case PAYMENT_METHOD.BRAINTREE: {
      PaymentMethodComponent = Braintree
      break
    }
    case PAYMENT_METHOD.BRAINTREE_PAYPAL: {
      PaymentMethodComponent = BraintreePaypal
      break
    }
    case PAYMENT_METHOD.CHECK_MONEY_ORDER: {
      PaymentMethodComponent = CheckMo
      break
    }
    case PAYMENT_METHOD.CYBERSOURCE: {
      PaymentMethodComponent = Cybersource
      break
    }
    case PAYMENT_METHOD.KLARNA_PAY_LATER:
    case PAYMENT_METHOD.KLARNA_PAY_NOW:
    case PAYMENT_METHOD.KLARNA_PAY_OVER_TIME:
    case PAYMENT_METHOD.KLARNA_SLICE_IT: {
      PaymentMethodComponent = Klarna
      break
    }
    case PAYMENT_METHOD.MERCHANTE: {
      PaymentMethodComponent = MerchantE
      break
    }
    case PAYMENT_METHOD.PAYFLOW_PRO: {
      PaymentMethodComponent = PayflowPro
      break
    }
    case PAYMENT_METHOD.PAYPAL_EXPRESS: {
      PaymentMethodComponent = PaypalExpress
      break
    }
    case PAYMENT_METHOD.FREE: {
      PaymentMethodComponent = Free
      break
    }
    default: {
      return null
    }
  }

  return (
    <PaymentMethodComponent
      key={code}
    />
  )
}
